import { render, staticRenderFns } from "./zhengzhuang.vue?vue&type=template&id=8046fbbc&scoped=true&"
import script from "./zhengzhuang.vue?vue&type=script&lang=ts&"
export * from "./zhengzhuang.vue?vue&type=script&lang=ts&"
import style0 from "./zhengzhuang.vue?vue&type=style&index=0&id=8046fbbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8046fbbc",
  null
  
)

export default component.exports